import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import InviteInterpreterList from 'views/appointment/view/InviteInterpreterTable';

function InviteInterpreterModal({
    isOpen,
    onClose,
    appointment
}) {
    if (!appointment) return null;

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            centered
            size="xl"
            backdrop="static"
        >
            <ModalHeader className='header_modal align-items-center' toggle={onClose}>
              <h5 className="modal-title_u">Invite Interpreters { appointment.appid}</h5>
            </ModalHeader>
            <ModalBody className="p-0">
              
                <InviteInterpreterList
                    itemId={appointment.id}
                    appointmentData={appointment}
                    isModal={true}
                />
            </ModalBody>
        </Modal>
    );
}

export default InviteInterpreterModal;
